<template>
  <div class="geobooster-widgets-edit-form">
    <div class="geobooster-widgets-edit-form__line">
      <p>Embed the following code snippet into your website to display {{ gbName }} moments.</p>
    </div>
    <div
      class="geobooster-widgets-edit-form__line"
      @click="copyEmbedCode">
      <div class="geobooster-widgets-edit-form__code">
        <pre>{{ embedCode() }}</pre>
        <i class="far fa-copy" aria-hidden="true" />
      </div>
    </div>
  </div>
</template>

<script>
import getWidgetEmbedCode from '../mixins/getWidgetEmbedCode'
import copyToClipboard from '../../../../common/copy_to_clipboard'

export default {
  mixins: [
    getWidgetEmbedCode
  ],
  props: {
    configuration: {
      type: Object,
      required: true
    },
    widgetSrc: {
      type: String,
      required: true
    }
  },
  computed: {
    gbName() {
      return Styxie.WLC.gbName
    }
  },
  methods: {
    copyEmbedCode() {
      copyToClipboard(this.embedCode(), () => {
        toastr.success(`${this.gbName} widget code was copied to clipboard`)
      })
    }
  }
}
</script>
